export default __webpack_public_path__ + "static/media/work-1left-1.b45b6f3a.png";